import { NAV_ITEMS, PRIVACY } from "./constants";
import { scrollToId } from "../utils/scroll";

function Footer({ onView }) {
  return (
    <footer className="site-footer" id="footer">
      <div className="container">
        <div className="footer-top">
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 14,
                marginBottom: 22,
              }}
            >
              <img
                src="/images/raf9456logo.png"
                alt=""
                style={{ height: 56, width: "auto" }}
              />
              <div>
                <div className="brand__name" style={{ fontSize: "1.3rem", color: "var(--paper)" }}>
                  RAF Lodge 9456
                </div>
                <div
                  style={{
                    fontFamily: "var(--font-mono)",
                    fontSize: "0.7rem",
                    letterSpacing: "0.22em",
                    color: "#e9c97a",
                  }}
                >
                  PER ARDUA AD ASTRA
                </div>
              </div>
            </div>
            <p style={{ color: "rgba(247, 242, 231, 0.7)", maxWidth: "44ch" }}>
              The only RAF Freemasons' Lodge in the country to accept all RAF ranks,
              and those who share an interest in aviation.
            </p>
          </div>
          <div>
            <h4>Visit</h4>
            <ul>
              {NAV_ITEMS.map((i) => (
                <li key={i.id}>
                  <a
                    href={"#" + i.id}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToId(i.id);
                    }}
                  >
                    {i.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="#privacy"
                  onClick={(e) => {
                    e.preventDefault();
                    onView(PRIVACY);
                  }}
                >
                  Privacy
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4>Connect</h4>
            <ul>
              <li>
                <a
                  href="https://www.facebook.com/RAFLodge"
                  target="_blank"
                  rel="noreferrer"
                >
                  Facebook Page ↗
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/groups/471856354289594"
                  target="_blank"
                  rel="noreferrer"
                >
                  Facebook Group ↗
                </a>
              </li>
              <li>
                <a href="https://x.com/raf9456" target="_blank" rel="noreferrer">
                  X (Twitter) ↗
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/groups/9162009"
                  target="_blank"
                  rel="noreferrer"
                >
                  LinkedIn Group ↗
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-affiliations">
          <a
            href="https://warwickshirefreemasons.org.uk/"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="/images/pglwApprovedWebsite.png"
              alt="Provincial Grand Lodge of Warwickshire approved website"
            />
          </a>
          <a href="https://www.ugle.org.uk/" target="_blank" rel="noreferrer">
            <img
              src="/images/accreditedLodgeWebsite.jpeg"
              alt="UGLE accredited lodge website"
            />
          </a>
          <p
            className="footer-disclaimer"
            style={{ flex: 1, minWidth: 280, margin: 0 }}
          >
            We cannot guarantee that any link or feed from this site has been approved by
            the United Grand Lodge of England or the Provincial Grand Lodge of
            Warwickshire. Neither can we guarantee that subsequent links from their pages
            are recognised by, or have the approval of, those bodies.
          </p>
        </div>

        <div className="footer-bottom">
          <span>
            &copy; {new Date().getFullYear()} Warwickshire Royal Air Force Lodge No.
            9456
          </span>
          <span>Per Ardua Ad Astra</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
